export const LOGIN_COLOR_THEME = "client";
export const LOGIN_MODE_THEME = "light";

export function applyLightLoginTheme(colorTheme = LOGIN_COLOR_THEME) {
    if (typeof document === "undefined") {
        return null;
    }

    const root = document.documentElement;
    root.dataset.authIntent = colorTheme;
    root.dataset.theme = LOGIN_MODE_THEME;
    root.dataset.themePreference = LOGIN_MODE_THEME;
    root.classList.remove("dark");
    root.style.colorScheme = LOGIN_MODE_THEME;

    if (document.body) {
        document.body.classList.remove("dark");
        document.body.style.colorScheme = LOGIN_MODE_THEME;
    }

    return root;
}
